<template>
  <div v-if="ticket" class="tw-flex tw-flex-col tw-h-full tw-min-h-0">
    <!-- Header -->
    <div
      class="tw-flex tw-items-center tw-justify-between tw-gap-2 tw-mb-2 tw-shrink-0"
    >
      <button
        type="button"
        class="md:tw-hidden tw-text-sm tw-text-slate-500 hover:tw-text-slate-700"
        @click="$emit('back')"
      >
        ‹ Lista
      </button>
      <div class="tw-flex tw-items-center tw-gap-2 tw-min-w-0">
        <span class="tw-font-semibold tw-text-slate-800 tw-truncate">
          {{ catMeta(ticket.category).icon }}
          {{ catMeta(ticket.category).label }}
        </span>
        <span
          class="tw-text-xs tw-rounded-full tw-px-2 tw-py-0.5"
          :class="statusTone(ticket.status)"
        >
          {{ statusLabel(ticket.status, "user") }}
        </span>
      </div>
    </div>
    <p class="tw-text-[11px] tw-text-slate-400 tw-mb-2 tw-shrink-0">
      Aperto il {{ formatDate(ticket.createdAt) }}
      <span v-if="ticket.pageUrl"> · {{ ticket.pageUrl }}</span>
    </p>

    <!-- Conversazione -->
    <FeedbackConversation
      class="tw-flex-1 tw-min-h-0"
      role="user"
      :messages="ticket.messages || []"
      :can-reply="isOpen"
      :sending="sending"
      @send="$emit('send', $event)"
    >
      <template #closed>
        <button
          type="button"
          class="tw-text-xs tw-bg-fb-accent tw-text-white tw-rounded-lg tw-px-3 tw-py-1.5 hover:tw-bg-fb-accent-hover"
          @click="$emit('new')"
        >
          + Apri nuovo ticket
        </button>
      </template>
    </FeedbackConversation>
  </div>

  <div
    v-else
    class="tw-flex tw-items-center tw-justify-center tw-h-full tw-text-sm tw-text-slate-400"
  >
    Seleziona un ticket dalla lista oppure aprine uno nuovo.
  </div>
</template>

<script>
import {
  categoryMeta,
  statusLabel,
  statusTone,
} from "../services/feedbackService";
import FeedbackConversation from "./FeedbackConversation.vue";

export default {
  name: "FeedbackTicketDetail",
  components: { FeedbackConversation },
  props: {
    ticket: { type: Object, default: null },
    sending: { type: Boolean, default: false },
  },
  emits: ["back", "new", "send"],
  computed: {
    isOpen() {
      const t = this.ticket;
      return !!t && !t.resolved && t.status !== "archived" && !t.expired;
    },
  },
  methods: {
    catMeta(v) {
      return categoryMeta(v);
    },
    statusLabel,
    statusTone,
    formatDate(d) {
      try {
        return new Date(d).toLocaleString("it-IT");
      } catch {
        return "";
      }
    },
  },
};
</script>
